import React from 'react'
import { Cointainer, CustomNavLink, CustomNavLink1, CPersonIcon, CPersonOutlineIcon, CHiOutlineDotsCircleHorizontal, CBiCalendar } from '../../style/PMCStyle/PMCSidebar'
import { CustomDiv } from '../../style/shared'
import Cal from "../../assets/sidebar/calendar.svg"
import User from "../../assets/sidebar/user.svg"
import Menu from "../../assets/sidebar/menu.svg"
import Person from "../../assets/sidebar/person.svg"
import CalA from "../../assets/sidebar/calendarA.svg"
import UserA from "../../assets/sidebar/userA.svg"
import MenuA from "../../assets/sidebar/menuA.svg"
import PersonA from "../../assets/sidebar/personA.svg"

export const PMCSidebar = ({config}) => {
    const renderNavLink = (item, isActive) => {
        return (
            <CustomNavLink to={item.path} className={isActive ? 'active' : ''}>
                <img 
                    src={isActive ? item.activeIcon : item.icon} 
                    style={{ width: "21px", margin: '7px 0px 7px 7px' }} 
                    alt={item.alt} 
                />
            </CustomNavLink>
        );
    };
    return (
        <Cointainer className='noAfter'>
            <CustomDiv marginT="150px">
                {config.map((item, index) => {
                    const isActive = window.location.href.includes(item.path);
                    return item.path ? (
                        renderNavLink(item, isActive)
                    ) : (
                        <CustomNavLink1 key={index} to={item.path}>
                            <img 
                                src={item.icon} 
                                style={{ width: "21px", margin: '7px 0px 7px 7px' }} 
                                alt={item.alt} 
                            />
                        </CustomNavLink1>
                    );
                })}
            </CustomDiv>
        </Cointainer>
    );
}

export default PMCSidebar